import type { ExcelGridColumn } from "../../shared/excel-grid/models/excel-grid.models";

export const ADMIN_ONBOARDING_COLUMNS: ExcelGridColumn[] = [
  { key: "VESSEL_NAME", label: "Vessel", minWidth: 200 },
  { key: "VESSEL_CODE", label: "Vessel code", minWidth: 130 },
  { key: "IMO_NUMBER", label: "IMO", minWidth: 110 },
  { key: "EMAIL", label: "Master email", minWidth: 260, maxWidth: 400 },
  { key: "CREATED_AT", label: "Created at", minWidth: 230 },
  { key: "ACTIVATED", label: "Activated", minWidth: 120 },
  { key: "ACTIVATED_AT", label: "Activated at", minWidth: 230 },
].map((column) => ({ ...column, editable: false, sortable: true, filterable: true }));
